import type { SignInSchema } from '@coas/validators/payload';
import { useMutation } from '@tanstack/react-query';
import type { APIError } from 'better-auth';
import { useRouter, useSearchParams } from 'next/navigation';
import { toast } from 'sonner';
import { authClient } from '~/shared/lib/auth';

export const useSignInMutation = () => {
    const router = useRouter();
    const searchParams = useSearchParams();

    return useMutation<void, APIError, SignInSchema>({
        mutationKey: ['signInOtp'],

        mutationFn: async ({ provider, data }) => {
            if (provider === 'phone') {
                const { error } = await authClient.phoneNumber.sendOtp({
                    phoneNumber: data.phoneNumber,
                });
                if (error) throw error;
            } else {
                const { error } = await authClient.emailOtp.sendVerificationOtp({
                    email: data.email,
                    type: 'sign-in',
                });
                if (error) throw error;
            }
        },

        retry: false,

        onError: (error, variables) => {
            const isPhone = variables.provider === 'phone';

            switch (error.status) {
                case 400:
                    toast.error('Неверный формат данных');
                    break;
                case 401:
                    toast.error(isPhone ? 'Номер не найден или заблокирован' : 'Email не найден или заблокирован');
                    break;
                case 409:
                    toast.error('Код уже отправлен, попробуйте позже');
                    break;
                case 429:
                    break;
                default:
                    toast.error(error.message || 'Неизвестная ошибка при отправке кода');
            }
        },

        onSuccess: (_, variables) => {
            const redirect = searchParams.get('redirect');
            const params = new URLSearchParams({ provider: variables.provider });

            if (variables.provider === 'phone') {
                params.set('phoneNumber', variables.data.phoneNumber);
            } else {
                params.set('email', variables.data.email);
            }

            if (redirect) {
                params.set('redirect', redirect);
            }

            router.replace(`/auth/verify?${params.toString()}`);
        },
    });
};
